import * as userService from "../services/UserService";
import { FormBaseController } from "../components/fx";

const formConfig: any = {
    pageTitle: "User Form",
    sections: [
        {
            type: "form",
            layout: 4,
            controls: [
                { label: 'Display Name', model: 'displayName', type: 'text', validations: ["required"] },
                { label: 'E-Mail', model: 'email', type: 'text', controlRule: { disableExpression: "formModel.registrationStatus == 'Completed'" }, validations: ["required", "email"] },
                { label: 'Mobile', model: 'mobile', type: 'text' },
                { label: 'Roles', model: 'roleCode', type: 'combo', valueField: 'code', displayField: 'text', lookupKey: 'Roles', validations: ["required"] },
                { label: 'Registration Status', model: 'registrationStatus', type: 'text', controlRule: { disableExpression: true }, defaultValue: "DRAFT" },
                { label: 'Is Disabled', model: 'isDisabled', type: 'checkbox', defaultValue: false }
            ],
            actions: [
                { name: "add" },
                { name: "update" },
                { name: "cancel" }
            ]
        }
    ]
}

const formBaseController = FormBaseController({
    formConfig,
    actions: {
        add: userService.addUser,
        update: userService.updateUser,
        getItemById: userService.getUserById,
        getLookups: userService.getLookups
    }
}
);

export const useUserFormStore = formBaseController.getStore();
